import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";

export const LeadPicker = ({ value, onChange }) => {
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (q.trim().length < 2) { setItems([]); return undefined; }
    const t = setTimeout(() => api.get("/leads", { params: { q, page: 1, page_size: 8 } }).then((r) => setItems(r.data.items)), 250);
    return () => clearTimeout(t);
  }, [q]);

  if (value) {
    return (
      <div className="flex items-center justify-between rounded-xl border border-slate-200 px-3 py-2 text-sm" data-testid="lead-picker-selected">
        <span className="font-semibold">{value.full_name}</span>
        <button className="text-xs text-[#1E6FD9]" onClick={() => onChange(null)} data-testid="lead-picker-clear">Cambiar</button>
      </div>
    );
  }
  return (
    <div>
      <Input placeholder="Buscar por nombre o teléfono" value={q} onChange={(e) => setQ(e.target.value)} className="rounded-xl" data-testid="lead-picker-input" />
      {items.length > 0 && (
        <ul className="mt-1 max-h-48 overflow-auto rounded-xl border border-slate-200 bg-white text-sm">
          {items.map((l) => (
            <li key={l.id}>
              <button className="w-full px-3 py-2 text-left hover:bg-[#F5F7FA]" onClick={() => onChange(l)} data-testid={`lead-picker-option-${l.id}`}>
                {l.full_name} <span className="text-xs text-slate-400">{l.phone}</span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
